import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBuilding, FaUser, FaMapMarkerAlt, FaPhone, FaEnvelope, FaSave, FaArrowLeft, FaGlobe } from 'react-icons/fa';
import styled from 'styled-components';
import { clientService } from '../services/api';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #667eea;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(102, 126, 234, 0.1);
  }
`;

const Title = styled.h1`
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
`;

const FormContainer = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const FormHeader = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 30px;
  text-align: center;
`;

const FormTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
`;

const FormSubtitle = styled.p`
  margin: 10px 0 0 0;
  opacity: 0.9;
  font-size: 16px;
`;

const FormContent = styled.div`
  padding: 40px;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
`;

const Section = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #667eea;
  }
`;

const SectionTitle = styled.h3`
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #2c3e50;
  font-weight: 500;
  font-size: 14px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
  
  &:disabled {
    background: #f8f9fa;
    color: #6c757d;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

// TextArea component removed as it's not being used

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  padding-top: 30px;
  border-top: 1px solid #e9ecef;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  
  ${props => props.primary ? `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  ` : `
    background: white;
    color: #6c757d;
    border: 2px solid #e1e5e9;
    
    &:hover {
      border-color: #667eea;
      color: #667eea;
    }
  `}
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

const ErrorMessage = styled.div`
  background: #fee;
  color: #c33;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #fcc;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #c3e6cb;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const EmpresaCadastro = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [cidades, setCidades] = useState([]);
  const [loadingCidades, setLoadingCidades] = useState(true);
  
  const [formData, setFormData] = useState({
    nome_fantasia: '',
    razao_social: '',
    cnpj: '',
    cidade_id: '',
    telefone: '',
    celular: '',
    endereco: '',
    numero: '',
    bairro: '',
    cep: '',
    usuario_email: '',
    usuario_nome: ''
  });

  // Carregar cidades ao montar o componente
  useEffect(() => {
    const fetchCidades = async () => {
      try {
        setLoadingCidades(true);
        const data = await clientService.getCidades();
        setCidades(data);
      } catch (err) {
        console.error('Erro ao carregar cidades:', err);
        setError('Erro ao carregar lista de cidades');
      } finally {
        setLoadingCidades(false);
      }
    };

    fetchCidades();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Validações básicas
      if (!formData.nome_fantasia || !formData.razao_social || !formData.cnpj) {
        throw new Error('Preencha todos os campos obrigatórios da empresa');
      }

      if (!formData.usuario_nome || !formData.usuario_email) {
        throw new Error('Preencha todos os campos obrigatórios do administrador');
      }

      if (!formData.cidade_id) {
        throw new Error('Selecione uma cidade');
      }

      // Criar payload no formato esperado pela API
      const payload = {
        nome_fantasia: formData.nome_fantasia,
        razao_social: formData.razao_social,
        cnpj: formData.cnpj,
        cidade_id: parseInt(formData.cidade_id),
        telefone: formData.telefone,
        celular: formData.celular,
        endereco: formData.endereco,
        numero: formData.numero,
        bairro: formData.bairro,
        cep: formData.cep,
        usuario_email: formData.usuario_email,
        usuario_nome: formData.usuario_nome
      };

      const response = await clientService.createEmpresa(payload);
      
      // Mostrar mensagem de sucesso com o email
      setSuccess(response.message || 'Empresa está sendo criada. Você receberá um email com as informações de acesso em breve.');
      
      // Redireciona após 3 segundos
      setTimeout(() => {
        navigate('/clientes');
      }, 3000);

    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erro ao criar empresa');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/clientes');
  };

  return (
    <Container>
      <Header>
        <BackButton onClick={handleBack}>
          <FaArrowLeft />
          Voltar
        </BackButton>
        <Title>Cadastrar Nova Empresa</Title>
      </Header>

      <FormContainer>
        <FormHeader>
          <FormTitle>Nova Empresa</FormTitle>
          <FormSubtitle>Preencha os dados da empresa e do administrador</FormSubtitle>
        </FormHeader>

        <FormContent>
          {error && (
            <ErrorMessage>
              <FaEnvelope />
              {error}
            </ErrorMessage>
          )}

          {success && (
            <SuccessMessage>
              <FaBuilding />
              {success}
            </SuccessMessage>
          )}

          <form onSubmit={handleSubmit}>
            <FormGrid>
              {/* Seção da Empresa */}
              <Section>
                <SectionTitle>
                  <FaBuilding />
                  Dados da Empresa
                </SectionTitle>

                <FormGroup>
                  <Label>Nome Fantasia *</Label>
                  <Input
                    type="text"
                    value={formData.nome_fantasia}
                    onChange={(e) => handleInputChange('nome_fantasia', e.target.value)}
                    placeholder="Nome da empresa"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Razão Social *</Label>
                  <Input
                    type="text"
                    value={formData.razao_social}
                    onChange={(e) => handleInputChange('razao_social', e.target.value)}
                    placeholder="Razão Social LTDA"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>CNPJ *</Label>
                  <Input
                    type="text"
                    value={formData.cnpj}
                    onChange={(e) => handleInputChange('cnpj', e.target.value)}
                    placeholder="00.000.000/0000-00"
                    required
                  />
                </FormGroup>
              </Section>

              {/* Seção de Endereço */}
              <Section>
                <SectionTitle>
                  <FaMapMarkerAlt />
                  Endereço
                </SectionTitle>

                <FormGroup>
                  <Label>CEP</Label>
                  <Input
                    type="text"
                    value={formData.cep}
                    onChange={(e) => handleInputChange('cep', e.target.value)}
                    placeholder="00000-000"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Endereço</Label>
                  <Input
                    type="text"
                    value={formData.endereco}
                    onChange={(e) => handleInputChange('endereco', e.target.value)}
                    placeholder="Rua, Avenida, etc."
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Número</Label>
                  <Input
                    type="text"
                    value={formData.numero}
                    onChange={(e) => handleInputChange('numero', e.target.value)}
                    placeholder="123"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Bairro</Label>
                  <Input
                    type="text"
                    value={formData.bairro}
                    onChange={(e) => handleInputChange('bairro', e.target.value)}
                    placeholder="Centro"
                  />
                </FormGroup>
              </Section>

              {/* Seção de Contato */}
              <Section>
                <SectionTitle>
                  <FaPhone />
                  Contato
                </SectionTitle>

                <FormGroup>
                  <Label>Telefone</Label>
                  <Input
                    type="text"
                    value={formData.telefone}
                    onChange={(e) => handleInputChange('telefone', e.target.value)}
                    placeholder="4333334444"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Celular</Label>
                  <Input
                    type="text"
                    value={formData.celular}
                    onChange={(e) => handleInputChange('celular', e.target.value)}
                    placeholder="43999998888"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    <FaGlobe style={{ marginRight: '8px' }} />
                    Cidade *
                  </Label>
                  <Select
                    value={formData.cidade_id}
                    onChange={(e) => handleInputChange('cidade_id', e.target.value)}
                    disabled={loadingCidades}
                    required
                  >
                    <option value="">Selecione uma cidade</option>
                    {cidades.map((cidade) => (
                      <option key={cidade.id} value={cidade.id}>
                        {cidade.nome} - {cidade.estado?.nome || cidade.estado_nome}
                      </option>
                    ))}
                  </Select>
                  {loadingCidades && (
                    <small style={{ color: '#6c757d', marginTop: '5px', display: 'block' }}>
                      Carregando cidades...
                    </small>
                  )}
                  {!loadingCidades && cidades.length === 0 && (
                    <small style={{ color: '#dc3545', marginTop: '5px', display: 'block' }}>
                      Erro ao carregar cidades. Tente recarregar a página.
                    </small>
                  )}
                </FormGroup>
              </Section>

              {/* Seção do Administrador */}
              <Section>
                <SectionTitle>
                  <FaUser />
                  Administrador
                </SectionTitle>

                <FormGroup>
                  <Label>Nome do Administrador *</Label>
                  <Input
                    type="text"
                    value={formData.usuario_nome}
                    onChange={(e) => handleInputChange('usuario_nome', e.target.value)}
                    placeholder="Nome completo"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Email do Administrador *</Label>
                  <Input
                    type="email"
                    value={formData.usuario_email}
                    onChange={(e) => handleInputChange('usuario_email', e.target.value)}
                    placeholder="admin@empresa.com"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <small style={{ color: '#6c757d', fontSize: '13px', display: 'block', marginTop: '-10px', marginBottom: '10px' }}>
                    ℹ️ A senha será enviada por email após a criação da empresa
                  </small>
                </FormGroup>
              </Section>
            </FormGrid>

            <ButtonGroup>
              <Button type="button" onClick={handleBack}>
                Cancelar
              </Button>
              <Button type="submit" primary disabled={loading}>
                {loading ? (
                  <>
                    <LoadingSpinner />
                    Criando...
                  </>
                ) : (
                  <>
                    <FaSave />
                    Criar Empresa
                  </>
                )}
              </Button>
            </ButtonGroup>
          </form>
        </FormContent>
      </FormContainer>
    </Container>
  );
};

export default EmpresaCadastro; 